import { arrayOf } from 'normalizr'
import person from 'components/people/person/actions/schema'

export default arrayOf(person)
